import { useQuery } from '@tanstack/react-query'
import { loomApi } from '@/lib/loom-graph'

/** Fetches the runtime-internal agent knowledge graph for the Loom view. */
export function useLoomGraph() {
  return useQuery({
    queryKey: ['loom-graph'],
    queryFn: () => loomApi.graph(),
    staleTime: 5 * 60_000,
  })
}
